export default __webpack_public_path__ + "static/media/Screenshot (1068).e202dcf8.png";